import { auth } from "../../api";

type UpdatePasswordProps = {
  oldPassword?: string;
  newPassword: string;
  resetToken?: string;
  authToken: string;
};

const useUpdatePassword = () => {
  const updatePassword = async ({
    oldPassword,
    newPassword,
    resetToken,
    authToken,
  }: UpdatePasswordProps) => {
    try {
      localStorage.setItem("token", authToken || "");
      const response = await auth.authPut("password", {
        oldPassword,
        newPassword,
        resetToken,
      });
      return response.data;
    } catch (error) {
      return error;
    }
  };

  return { updatePassword };
};

export default useUpdatePassword;
